import React, { useState, useCallback, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeOverlayStatus } from "../../../state/actionCreators";
import DeletePopup from "./DeletePopup";
import EditWebsitePopup from "./EditWebsitePopup";
import PauseResumeWebsite from "./PauseResumeWebsite";
import EditUserPopup from "./EditUserPopup";
import EditSubscriptionPopup from "./EditSubscriptionPopup";
import EditPaymentPopup from "./EditPaymentPopup";
import EditTicketPopup from "./EditTicketPopup";
import EditColdEmailPopup from "./EditColdEmailPopup";

const PopupModal = React.forwardRef((props, ref) => {

    const [displayPopup, setDisplayPopup] = useState(false);
    const [action, setAction] = useState("");
    const [data, setData] = useState({});
    const [error, setError] = useState("");
    const dispatch = useDispatch();

    useImperativeHandle(ref, () => ({
        openPopup,
        closePopup,
    }));

    // Open popup
    const openPopup = useCallback(
        (action, popupData = {}) => {
            setDisplayPopup(true);
            setAction(action);
            setData(popupData);
            setError("");
            dispatch(changeOverlayStatus("true"));
        },
        [dispatch]
    );

    // Close popup
    const closePopup = useCallback(() => {
        setDisplayPopup(false);
        setAction("");
        setData({});
        setError("");
        dispatch(changeOverlayStatus("false"));
    }, [dispatch]);

    // Update error
    const updateError = useCallback((errMsg) => {
        setError(errMsg);
    }, []);

    const renderPopupContent = () => {
        const popupProps = {
            data,
            updateError,
            closePopup,
        };

        switch (action) {
            case "deleteWebsite":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="website"
                        deleteWebsite={props.deleteWebsite}
                    />
                );

            case "pauseWebsite":
                return (
                    <PauseResumeWebsite
                        {...popupProps}
                        type="pause"
                        updateWebsite={props.updateWebsite}
                    />
                );

            case "resumeWebsite":
                return (
                    <PauseResumeWebsite
                        {...popupProps}
                        type="resume"
                        updateWebsite={props.updateWebsite}
                    />
                );

            case "editWebsite":
                return (
                    <EditWebsitePopup
                        {...popupProps}
                        type="update"
                        updateWebsite={props.updateWebsite}
                    />
                )

            case "addUser":
                return (
                    <EditUserPopup
                        {...popupProps}
                        type="add"
                        addUser={props.addUser}
                    />
                )

            case "editUser":
                return (
                    <EditUserPopup
                        {...popupProps}
                        type="update"
                        updateUser={props.updateUser}
                    />
                )

            case "deleteUser":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="user"
                        deleteUser={props.deleteUser}
                    />
                );


            case "addSubscription":
                return (
                    <EditSubscriptionPopup
                        {...popupProps}
                        type="add"
                        addSubscription={props.addSubscription}
                    />
                )

            case "editSubscription":
                return (
                    <EditSubscriptionPopup
                        {...popupProps}
                        type="update"
                        updateSubscription={props.updateSubscription}
                    />
                )

            case "deleteSubscription":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="subscription"
                        deleteSubscription={props.deleteSubscription}
                    />
                );

            case "addPayment":
                return (
                    <EditPaymentPopup
                        {...popupProps}
                        type="add"
                        addPayment={props.addPayment}
                    />
                )

            case "editPayment":
                return (
                    <EditPaymentPopup
                        {...popupProps}
                        type="update"
                        updatePayment={props.updatePayment}
                    />
                )

            case "deletePayment":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="payment"
                        deletePayment={props.deletePayment}
                    />
                );

            case "addTicket":
                return (
                    <EditTicketPopup
                        {...popupProps}
                        type="add"
                        addTicket={props.addTicket}
                    />
                )

            case "editTicket":
                return (
                    <EditTicketPopup
                        {...popupProps}
                        type="update"
                        updateTicket={props.updateTicket}
                    />
                )

            case "deleteTicket":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="ticket"
                        deleteTicket={props.deleteTicket}
                    />
                );

            case "editColdEmail":
                return (
                    <EditColdEmailPopup
                        {...popupProps}
                        type="update"
                        updateColdEmail={props.updateColdEmail}
                    />
                );

            case "deleteColdEmail":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="coldEmail"
                        deleteColdEmail={props.deleteColdEmail}
                    />
                );

            default:
                return null;
        }
    };

    return (
        <div
            className={`mjsdev-popup ${
                displayPopup ? "fade-in" : "mjsdev-hidden"
            }`}
        >
            <div className="mjsdev-popup-inner">
                <span className="mjsdev-popup-close" onClick={closePopup}>
                    <i className="fa-solid fa-xmark"></i>
                </span>

                {renderPopupContent()}

                {error && <div className="mjsdev-error">{error}</div>}
            </div>
        </div>
    );
});

export default PopupModal;
